"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.PricesHolder = exports.Plus = exports.OldPrice = exports.MrpStatement = exports.GamificationPricesHolder = exports.GamificationCurrentPrice = exports.CurrentPriceAndPoints = exports.CurrentPrice = exports.CurrencyWrapper = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
var _utils = require("./utils");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1)
}));
const PricesHolder = exports.PricesHolder = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexGrow: 1,
  gap: theme.spacing(1, 2),
  justifyContent: 'flex-start',
  flexWrap: 'wrap'
}));
const CurrentPrice = exports.CurrentPrice = (0, _mui.styled)(_mui.Typography, {
  shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)(['useOfferColor'])
})(({
  useOfferColor,
  theme
}) => ({
  color: (0, _utils.getCurrentPriceColor)(theme, useOfferColor),
  overflow: 'hidden'
}));
const OldPrice = exports.OldPrice = (0, _mui.styled)(_mui.Typography, {
  shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)(['useLineThrough'])
})(({
  useLineThrough,
  theme
}) => ({
  color: theme.palette.grey.A700,
  overflow: 'hidden',
  textDecoration: useLineThrough ? 'line-through' : undefined
}));
const CurrentPriceAndPoints = exports.CurrentPriceAndPoints = (0, _mui.styled)('div')({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'row'
});
const CurrencyWrapper = exports.CurrencyWrapper = (0, _mui.styled)('span')({
  display: 'flex',
  fontSize: '1.6rem'
});
const GamificationPricesHolder = exports.GamificationPricesHolder = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1)
}));
const GamificationCurrentPrice = exports.GamificationCurrentPrice = (0, _mui.styled)(CurrentPrice)(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: theme.spacing(1)
}));
const Plus = exports.Plus = (0, _mui.styled)('span')({
  alignItems: 'center',
  display: 'flex',
  marginTop: -3
});
const MrpStatement = exports.MrpStatement = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  color: theme.palette.text.secondary
}));
//# sourceMappingURL=styles.js.map